import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from 'Components/Button';
import HollowButton from 'Components/Button/HollowButton';
import PrimaryButton from 'Components/Button/PrimaryButton';
import RightPointerIcon from 'Components/icons/right-pointer-icon';

import './TimelineStageElement.scss';

const TimelineStageElement = ({
  id,
  showLatestStage,
  headerText,
  isOpen,
  toggleAccordion,
  directionalText,
  headerObjects,
  leftLinkButtonText,
  leftLinkButtonAction,
  linkButtonText,
  secondaryButtonText,
  primaryButtonAction,
  primaryButtonText,
  showFooterLeft,
  hidden,
  extraClass,
  hideToggleButton,
  headerActionMethod,
  contentIndex,
  headerButtonName,
  headerButtonStyle,
  pageSelected,
  showEditButton,
  slideOutButtons,
  status,
  isMerchantUser,
  toggleButtons
}) => {
  const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
  const headerClass = classnames('wizard-accordion__header', {
    'wizard-accordion__header--toggled': isOpen,
  });
  const toggleClass = classnames('timeline-accordion__toggler', {
    'timeline-accordion__toggler--expanded': isOpen,
    'timeline-accordion__toggler--collapsed': !isOpen,
  });
  const bodyClass = classnames('wizard-accordion__body', {
    'wizard-accordion__body--expanded': isOpen,
  });

  const headerConditionalClass = classnames('wizard-accordion__headline', {
    'wizard-accordion__headline_merchant': isMerchantUser,
  });

  const wrapperClass = (extraClass !== undefined && extraClass) ? extraClass : 'wizard-accordion__wrapper';
  const headerButton = headerButtonName && (
    <button
      type="button"
      onClick={() => headerActionMethod(contentIndex)}
      style={{
        float: 'right',
        backgroundColor: '#007dc3',
        color: 'white',
        border: '1px solid white',
        width: '73px',
        cursor: 'pointer',
      }}
    >
      {headerButtonName}
    </button>
  );

  const CaseStageHeaderMerchant = () => {
    return (
      <h1 className= {headerConditionalClass} onClick={toggleAccordion}>
        {headerText}
        {headerObjects && headerObjects}
        {status && status}
      </h1>
    );
  };

  const CaseStageHeader = () => {
    return (
      <h1 className= {headerConditionalClass} onClick={toggleAccordion}>
        {showLatestStage}
        {headerText}
        {status && status}
        {headerObjects && headerObjects}
      </h1>
    );
  };

  return (
    <article className={`${wrapperClass} ${hidden}`}>
      <header
        role="button"
        tabIndex={0}
        className={headerClass}
        id={id}
      >
        {!hideToggleButton && <span className={toggleClass} onClick={toggleAccordion} />}
        <>
          {isMerchantUser ? <CaseStageHeaderMerchant /> : <CaseStageHeader />}
        </>
        <>{slideOutButtons && slideOutButtons}</>
        <>{toggleButtons && toggleButtons}</>
      </header>
      <div className={bodyClass}>
        <div>
          <div className="wizard-accordion__content" />
          <footer className="wizard-accordion__footer">
            <div className="wizard-accordion__footer-left">
              {
                (showFooterLeft && leftLinkButtonText.length > 0)
                && (
                  <Button
                    action={leftLinkButtonAction}
                    category="link-inline"
                  >
                    {leftLinkButtonText}
                  </Button>
                )
              }
            </div>
            <div className="wizard-accordion__footer-right">
              {
                directionalText.length > 0
                && (
                  <span className="wizard-accordion__footer-right-text">
                    {directionalText}
                    {' '}
                    <RightPointerIcon />
                  </span>
                )
              }
              {linkButtonText
                && (
                  <Button
                    action={toggleAccordion}
                  >
                    {linkButtonText}
                  </Button>
                )}
              {secondaryButtonText && <HollowButton>{secondaryButtonText}</HollowButton>}
              {
                primaryButtonText
                && (
                  <PrimaryButton
                    action={() => primaryButtonAction(id)}
                  >
                    {primaryButtonText}
                  </PrimaryButton>
                )
              }
            </div>
          </footer>
        </div>
      </div>
    </article>
  );
};

TimelineStageElement.propTypes = {
  contentIndex: PropTypes.number,
  showLatestStage: PropTypes.object,
  directionalText: PropTypes.string,
  headerText: PropTypes.object.isRequired,
  headerButtonName: PropTypes.string,
  headerObjects: PropTypes.object,
  headerActionMethod: PropTypes.func,
  hideToggleButton: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  toggleAccordion: PropTypes.func.isRequired,
  leftLinkButtonText: PropTypes.string,
  leftLinkButtonAction: PropTypes.func,
  linkButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  pageSelected: PropTypes.bool,
  primaryButtonAction: PropTypes.func,
  primaryButtonText: PropTypes.string,
  id: PropTypes.string.isRequired,
  showFooterLeft: PropTypes.bool,
  extraClass: PropTypes.string,
  hidden: PropTypes.string,
  showEditButton: PropTypes.bool,
};

TimelineStageElement.defaultProps = {
  contentIndex: 0,
  directionalText: '',
  showLatestStage:{},
  headerObjects: {},
  headerButtonName: '',
  headerActionMethod: () => {},
  hideToggleButton: false,
  leftLinkButtonText: '',
  leftLinkButtonAction: () => { },
  linkButtonText: '',
  secondaryButtonText: '',
  pageSelected: false,
  primaryButtonAction: () => { },
  primaryButtonText: '',
  showFooterLeft: false,
  showEditButton: false,
  extraClass: '',
  hidden: '',
};

export default TimelineStageElement;
